module.exports = __webpack_public_path__ + "img/two_banner_mobile_bg4.db7e19c5.jpg";